webpackJsonp([114276838955818,60335399758886],{

/***/ 89:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./screen-jaguar.jpg": 413,
		"./screen-jet2.jpg": 414,
		"./screen-jet2holidays.jpg": 415,
		"./screen-landrover.jpg": 416
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 419;


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(186);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(89);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _brandModule = __webpack_require__(270);
	
	var _brandModule2 = _interopRequireDefault(_brandModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brand = function (_React$Component) {
		_inherits(Brand, _React$Component);
	
		function Brand(props) {
			_classCallCheck(this, Brand);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = {
				hovered: false
			};
			return _this;
		}
	
		Brand.prototype.toggleActiveState = function toggleActiveState(newState) {
			this.setState(function (prevState) {
				return {
					hovered: !prevState.hovered
				};
			});
		};
	
		Brand.prototype.render = function render() {
			var brand = this.props.brand;
			var overlayStyle = {
				backgroundColor: brand.color
			};
	
			var brandClass = this.state.hovered ? _brandModule2.default.brand + " " + _brandModule2.default.active : "" + _brandModule2.default.brand;
			return _react2.default.createElement(
				"div",
				{ className: brandClass,
					onClick: this.toggleActiveState.bind(this)
				},
				_react2.default.createElement(
					"div",
					{ className: _brandModule2.default.brandInner },
					_react2.default.createElement("img", { className: _brandModule2.default.brandImage, src: __webpack_require__(419)("./screen-" + brand.imageName + ".jpg"), alt: brand.name }),
					_react2.default.createElement(
						"div",
						{ className: _brandModule2.default.brandOverlay, style: overlayStyle },
						_react2.default.createElement("img", { className: _brandModule2.default.logoImage, src: __webpack_require__(418)("./logo-" + brand.imageName + ".png"), alt: brand.name })
					)
				)
			);
		};
	
		return Brand;
	}(_react2.default.Component);
	
	exports.default = Brand;
	module.exports = exports["default"];

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = BrandsContainer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Brand = __webpack_require__(182);
	
	var _Brand2 = _interopRequireDefault(_Brand);
	
	var _brandsContainerModule = __webpack_require__(271);
	
	var _brandsContainerModule2 = _interopRequireDefault(_brandsContainerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BrandsContainer(props) {
		var brands = [{
			name: 'Land Rover',
			color: '#005A2C',
			imageName: 'landrover'
		}, {
			name: 'Jet2.com',
			color: '#ee3123',
			imageName: 'jet2'
		}, {
			name: 'Jet2holidays',
			color: '#3d8ede',
			imageName: 'jet2holidays'
		}, {
			name: 'Jaguar',
			color: '#9e1b32',
			imageName: 'jaguar'
		}];
		return _react2.default.createElement(
			'div',
			{ className: _brandsContainerModule2.default.container },
			_react2.default.createElement(
				'div',
				{ className: _brandsContainerModule2.default.inner },
				_react2.default.createElement(
					'div',
					{ className: _brandsContainerModule2.default.info },
					_react2.default.createElement(
						'h4',
						{ className: _brandsContainerModule2.default.title },
						'Brands I\'ve worked with'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _brandsContainerModule2.default.brands },
					brands.map(function (brand, index) {
						return _react2.default.createElement(_Brand2.default, { key: index, brand: brand });
					})
				)
			)
		);
	}
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contactModule = __webpack_require__(272);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
		return Object.keys(data).map(function (key) {
			return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
		}).join("&");
	};
	
	var Contact = function (_React$Component) {
		_inherits(Contact, _React$Component);
	
		function Contact(props) {
			_classCallCheck(this, Contact);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.handleSubmit = function (e) {
				e.preventDefault();
	
				if (_this.state.sent) {
					return;
				}
	
				fetch("/", {
					method: "POST",
					headers: { "Content-Type": "application/x-www-form-urlencoded" },
					body: encode(_extends({ "form-name": "contact" }, _this.state))
				}).then(function () {
					_this.formSuccess();
				}).catch(function (error) {
					return alert(error);
				});
			};
	
			_this.formSuccess = function () {
				_this.setState({
					sent: true
				});
	
				setTimeout(function () {
					_this.returnToInitialState();
				}, 3000);
			};
	
			_this.returnToInitialState = function () {
				_this.setState(_this.initialState);
			};
	
			_this.handleChange = function (e) {
				var _this$setState;
	
				_this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
			};
	
			_this.initialState = { name: "", email: "", message: "", sent: false };
			_this.state = _this.initialState;
			return _this;
		}
	
		Contact.prototype.render = function render() {
			var _state = this.state,
			    name = _state.name,
			    email = _state.email,
			    message = _state.message;
	
			var submitMessage = this.state.sent ? 'Your message has been sent' : 'Send';
			return _react2.default.createElement(
				"div",
				{ className: _contactModule2.default.container },
				_react2.default.createElement(
					"div",
					{ className: _contactModule2.default.inner },
					_react2.default.createElement(
						"h1",
						{ className: _contactModule2.default.title },
						"Contact"
					),
					_react2.default.createElement(
						"form",
						{
							className: _contactModule2.default.form, onSubmit: this.handleSubmit
						},
						_react2.default.createElement(
							"div",
							{ className: _contactModule2.default.topTextContainer },
							_react2.default.createElement(
								"div",
								{ className: _contactModule2.default.inputContainer },
								_react2.default.createElement(
									"label",
									null,
									_react2.default.createElement(
										"span",
										{ className: _contactModule2.default.labelText },
										"Your name:"
									),
									_react2.default.createElement("input", { className: _contactModule2.default.input, type: "text", name: "name", value: name, onChange: this.handleChange })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: _contactModule2.default.inputContainer },
								_react2.default.createElement(
									"label",
									null,
									_react2.default.createElement(
										"span",
										{ className: _contactModule2.default.labelText },
										"Your email:"
									),
									_react2.default.createElement("input", { className: _contactModule2.default.input, type: "email", name: "email", value: email, onChange: this.handleChange })
								)
							)
						),
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"label",
								null,
								_react2.default.createElement(
									"span",
									{ className: _contactModule2.default.labelText },
									"Message:"
								),
								_react2.default.createElement("textarea", { name: "message", className: _contactModule2.default.message, value: message, onChange: this.handleChange })
							)
						),
						_react2.default.createElement(
							"div",
							null,
							_react2.default.createElement(
								"button",
								{ type: "submit", className: _contactModule2.default.submit },
								submitMessage
							)
						)
					)
				)
			);
		};
	
		return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = Footer;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(273);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer(props) {
		return _react2.default.createElement(
			"div",
			{ className: _footerModule2.default.footer },
			_react2.default.createElement(
				"div",
				{ className: _footerModule2.default.container },
				_react2.default.createElement(
					"p",
					null,
					"LukeEdmonds.com"
				),
				_react2.default.createElement(
					"a",
					{ target: "_blank", href: "https://www.linkedin.com/in/luke-edmonds-73421957/", className: "linkedin" },
					"Linked In"
				)
			)
		);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(85);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(374);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _layoutModule = __webpack_require__(274);
	
	var _layoutModule2 = _interopRequireDefault(_layoutModule);
	
	var _BrandsContainer = __webpack_require__(183);
	
	var _BrandsContainer2 = _interopRequireDefault(_BrandsContainer);
	
	var _Footer = __webpack_require__(185);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Contact = __webpack_require__(184);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: _layoutModule2.default.header },
	    _react2.default.createElement(
	      'div',
	      { className: _layoutModule2.default.headerInner },
	      _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _layoutModule2.default.title,
	            to: '/'
	          },
	          'Luke Edmonds'
	        )
	      )
	    )
	  );
	};
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Luke Edmonds - Front End Developer Leeds',
	      meta: [{ name: 'description', content: 'I am Luke Edmonds. A Front end web developer based in Leeds, England.' }, { name: 'keywords', content: 'freelance, contract, front end developer, ui ux developer, responsive ux ui developer, front end dev leeds, react developer leeds' }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _layoutModule2.default.topWrapper },
	      _react2.default.createElement(Header, null),
	      _react2.default.createElement(
	        'div',
	        { className: _layoutModule2.default.container },
	        _react2.default.createElement(
	          'h2',
	          { className: _layoutModule2.default.strapline },
	          'I\'m Luke. A Front end web developer based in Leeds, England.'
	        )
	      )
	    ),
	    _react2.default.createElement(_BrandsContainer2.default, null),
	    _react2.default.createElement(_Contact2.default, null),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(262);
	var isArguments = __webpack_require__(261);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"src-components-Brand----brand-module---brand---1pB3H","brandInner":"src-components-Brand----brand-module---brandInner---1yPJd","brandOverlay":"src-components-Brand----brand-module---brandOverlay---1DItg","active":"src-components-Brand----brand-module---active---27EeR","brandImage":"src-components-Brand----brand-module---brandImage---2lrHd","logoImage":"src-components-Brand----brand-module---logoImage---2qxid"};

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-BrandsContainer----brandsContainer-module---container---1lkho","inner":"src-components-BrandsContainer----brandsContainer-module---inner---13x65 src-styles----global---centredContainer---3bAlq","info":"src-components-BrandsContainer----brandsContainer-module---info---1srnv","brands":"src-components-BrandsContainer----brandsContainer-module---brands---1oVQ6","title":"src-components-BrandsContainer----brandsContainer-module---title---1frNj"};

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Contact----contact-module---container---1_EHC","inner":"src-components-Contact----contact-module---inner---24GZj src-styles----global---centredContainer---3bAlq","title":"src-components-Contact----contact-module---title---35HYZ","topTextContainer":"src-components-Contact----contact-module---topTextContainer---7BoAQ","form":"src-components-Contact----contact-module---form---2luXf","inputContainer":"src-components-Contact----contact-module---inputContainer---xpqaM","input":"src-components-Contact----contact-module---input---3sJia","message":"src-components-Contact----contact-module---message---96QJ3","labelText":"src-components-Contact----contact-module---labelText---1y9Q9","submit":"src-components-Contact----contact-module---submit---2VZSO"};

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","container":"src-components-Footer----footer-module---container---SePS1 src-styles----global---centredContainer---3bAlq"};

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(393);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(260);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(375);
	
	var _HelmetConstants = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(269);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(408);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-jaguar.b31061ea.png";

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAABZCAMAAACzO+mBAAADAFBMVEX///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+/LkhhAAAA/3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8PT4/QEFCQ0RFRkdISUpLTE1OT1BRUlNUVVZXWFlaW1xdXl9gYWJjZGVmZ2hpamtsbW5vcHFyc3R1dnd4eXp7fH1+f4CBgoOEhYaHiImKi4yNjo+QkZKTlJWWl5iZmpucnZ6foKGio6SlpqeoqaqrrK2ur7CxsrO0tba3uLm6u7y9vr/AwcLDxMXGx8jJysvMzc7P0NHS09TV1tfY2drb3N3e3+Dh4uPk5ebn6Onq6+zt7u/w8fLz9PX29/j5+vv8/f7rCNk1AAAZMElEQVQYGe3BCXzPdeA/8Nfu28YmG0ZzLjflbKgc0eXMkbtclSS5EpISIV+SSCIdY3JFjqST5L5i7hYaNuxk9/b6f97v7/fz/ny+3+277Vc9/v+f/6PnE/+beL6x+J33yuBu5lXlgdbdu3Xr1iMC/wNuzXp0E3pVRmHu97QaNHb2vHkzR3er7Q1lyNy335ryKu5e1RfGZrGAwksovXIbadMcjhq8+WsadXlnP37CF1bzH13zTaN3XXG36pVOXV5LlJrndtr8EQx7Udty6ODsiz4QXhs7edzzM3C3an6bSmJZlNpE6nbCTsWVuSzC4ebQ3LNqxpjtkbhbbafhO5RauSvUvQWzrvEs2u2noQns3L087lbNCqj5eh6FWSi1wVQ6weQtOpXTE3e5udRcKDOTQl+U2mfUJdeA4V0WI+k+3NXc95PMbhd4jZqsWigt3z+oOwzDiyzWetzVamaSnIZRFE77oLTuz6HuUyj3p7F4bXA360Zyl7vLYQqfo9SeozIEyjaa3FrZu/kDPVfdpsknKDX3wEAv/O8ynUyogU6UxsOef/la90VW9EYRFlCX9wB0j9Ik5l5ID8TScLEcSqFyl6nRe0/GxZ0+vNUyuK4bnKoY1feVWR/MGN29kS9Kw7VscFlXFFImuJwbSmED+QywjkJ8JBSvqEmrD/4Zn5qelnDxp7ndQ6Dz3nb+5MmTv6dRl3vm95OnDm/b+TCwg4bXoat9jYYHUZKggTuTaJK578VgFKXWxB9vFtAq+/ziB2EvsmM7qf0jZSC4t5q8OfbKlSu/xwwJhuLSaMxXxy799dfptYPLoyRtOjVzgVtU/wGjJ73XDroq087m0yzhowawapbHorVCi1wqi2F4hYbhKJ7/uMss5NJgFNJifQbt5O9oDLN1tMmOBOA9+GgedXGDYOXW4+ds6q70R/HcPKBxAQICa9T2g5XnuAQWkrkoGMIIFu1mGOZQOV8OhrBkKrNRrLa/s0irAmDn3ug8FpIxHia/0SalHPDwMdqZBaHB97QzA8WqHX/9VA3g61tJydl8E1K1n1mkc62giWHRfnNxP0PlRZh4/U7lYxRnfC6d2BoAk2duskgfu0IX/AdtTnphQg4djADw7B066I3idCW50xOvUBgBoflVOpHaAfA9y6J9gah86q5XgonPWSpL4JzLB3RuCQwz6cwC6Opl0Waby0IWcqUcZrCQc4EoxuvUvIHQqyTz6kLTIoFOpbZEGzoxGVOo/ACzxjlUXodzi1icJ2HjtoLODYRNB+qWTmERBoxgEQaiGJ9Tk90BC0j+GQig8XUaCtITb2TS5KTvwz9s2bJl4wEqJzdu0XyzowVe2bXFZtfzMPuIhu5wahyL9ZsbrN5lMS5XhtUo6i6mswinU1mEL+Ccy24KFwLqZZGbAbjtppL7VZdwX9/IcddomAnpVSpdUJLOBVTSasKZqGyapcTHJ+bRrDOkF2l27dfdlwpoMhtWy/h3HINz5eMprcYmcgaAF6hcewpWtc9QSawCYTV1CZVRgqbxNGyHM377aciO7lbZwzOwzSqafAihSToN54cEAN6dD9NwORjST7ST/fO890/RUf6B+ZajNEmEcw1pM6Iv2RXwPUNdSnPoHsyj8jw07uep+wUlaHmVJp3gzEs0XGwLm5E0nHQD4P4DDVuCIIUcoqEPhHIXaXbwQQCeq2gvtj0082hIgXP9aJOVwKxqQD8qw2BYQ2UrNHVvUzcbxRuaSpMv4UzQWSqx4VA2U7kVAWAEDTv9YBOVTWUBhIY02+QPITSeZj/fA8FtH5UUODeXhuM+wBbqfnOHoR+VU/4A+lDphuJUi6bZkfJwZgiVnNYwDKSS1wIIPEslPgLKd1T2QuhGkx1+sNpKk6OhsHqDygU4t5mG1UB4KnXPwaRmNnVxIQBmUZdUHc6Vn3qTZn/UgFM/U1kEk/Y0PAwMoGE4DBOoxPtAM4eGyxGwWUpDZnPY9KOyD06VOUvDVKAfdbdbVY1UqrfMoC4uGMBP1B2DU5WnxtPO0ZpwqkEGdXfqwqRMp8cfs3r8sbLATirHfGDoRiUpHJptNDwL3XIa3oVuGJVNcKpmLg0dgfepy4m/nWHIpPJHMFD2KnXL4ESk5Rbt/RgG50ZQ2Qrn7rtD5QWYdKGSXAVA2XNU9rtDt4PKtcrQvUXFAqeeoiGjKtyOsERHPIHW+dQ9hyLVWX6HDpb4ohhrqbwE556ncqsiTLpQSa4KoG4elYHQeR6lsgDKGiqvAPDfeGS/zYnBUF6j4Yg3KiSxRHsBDKfSFkWosiCDDm70Q3HcTlGX1wrOraOyAWa9qSQGA+hJ5VIQdFVvUpfXFDq3Q1Q6AqiQSmU0lE9pWAO0zmeJtgNYSd3VEBQSMPkmHX1VHcWKuEndzfJwyvs4lbEwm0LlojuA96gsgRJFZZ87dBFJ1KWFAgjPptIDOve9NLwODGTJNgEuJ6k7gEKePElHZ7qhBE3zqDvrAaeqpVBpC7O1VH6EZjuVHlDGUJkJ5SEqRz0BNC2g0gG6Ckk0tAEmsmQfAxFJ1H0MB2Ff0FHS634oSWcq+1zgVFMqaeVh4nWaykcAyl2kLjUUymdUOkMZR+UTaKJoaAhdRxqSKgPzqVyL+7NIidOAJ6m8Cnud4ugge3lVlOxxKlvg3ONULvjBpGkelREA6hZQ95sHdG77qUu9B8pnVMZD04OGBtC9S8MPAKKpy33IM7BIQZ7AWCo9YGdcLh1sboLSGEZlM5zrTWWPG0ymUclqBKAXlU+hVLlF3UFP6Fz2UWkHzdNU7lSHjc8JGt4DsI66W9Xg3Crq8lrB7H06+PEhlM5QKkdcYdJrykSbqZ2BXlR+dIHB6ziV424AZlF5BUobKiuhhCdSlxoKTU8qt6rAZiBNOgH4iro79eDcAerSImGyiPb2POGKIpVtWE9pUBmax6kkBsNkP5WVQC8qsT4w9KXhTWi2UGkDZSyViVDaUDnkCc0IGtrCKvIyDVdDAayj0hkGD38/nb8bEHSJusRQGGbSztFnPODEdGYrnApNFA1PwxBwicrbQFsq6eFQPA9SyWwAIPAsdSlhUFZR6QjlJSorIIynIbYVND49L9NkNTQxVObBMD7hvM3l732B2qnU3akPpSvNDvRwQyFunpDW06QnNGHxVL53h9KXhiHAfVlUBkMZR8OX0NTKpe6QF3QeB6i7XQnKZ1TGQ3iWJjm/Llu09gLtPAbNPCo3akAXHEtlAYAHC6isCff08vLydgXKnabJ9xXcg4IdhD+xYTqkkzTkPADhRxomQ1fxPJXMRoDfKSq/uMGmfQaV7Aeg6UnlCygR6dQd9Yayh8rDEJqzeHvdoXmWhl8rwypwM5WUmgDa0iTt6MFDJ9b7ApNodiPuL0fxWeRWCJUSafirPISXaPKOL6SGB2k46AJgJQ1zYNUpkYaFEGZRmQilHZXPoVRMoC41FILvSRYnszWEkHgarkxpWqlipSaTztHwFjRt6egXIOACS+E3CFEFNByGVPUGTWKnRlWv1ubDdJoMg+YJmkQ38IR7xPxMGmKDIWym0h7K61QmQ2lB5YAnpJdZnEmwmkQ7yTdSaLbfH5qH6Gge0IelsQfCMzT5Albv0l5ONu0c84XG6zBNso/vOnCbJhmtIQSeoy6tMpTVVNpBGUllBay899G5JbDxO8Ri3GwEoU46HQwANrA0FkF4iyYTYFX+DIuT3xHSMyzOMEi18qg75AWd91Hq0itBWUFlHGzqxdOZ1d7QNUumU8ntYbWfDpqi8nWWxmMQNtOkK2wezWUxJsJmLZ0bA6ueVD6HUvUOdYe9oPxCpQ10jf9k0d51haFjEp1IbAebxwto568wdGFpfAXB7QwNGQ2hG0nn3oSuwnE6cXsQbGZQGQ+lA5XPoYQlUJcSBqXqJhbhQjfYabSfRdpbB8rwOzTbC8xjKfwQDCHiFg2Xg6CMymPRUgbBUO13FunEg9BtoPIwlKlUJkFpQmWfBwwuXX7Jo73Tr5SBA79RF1hI/MveMGmyKYOGlcABlihphjek9jQ5AJPOV1iUbyJhVmE9C0ufGQidfyx1KeFQVlN5GMoIKitgx7XpO3uuF1DKvvTj/Ha+KEKZbtFxeTRk7hkTDHsuEb1femPeHGlhG3hMmD+nWHNn9QmFTYNFc5SFfWB2z7JsOsj5tiMcuPY9RXu3PqgOQ2QBdQc9oQuIpS4tHMoKKmPhyK1CnfadHn300furl3OBU4EN+735yZbvdu7cGTO7TzV3/F/T8MMrNKT8NK2+Cwrz7bn2Cm0K4jYOCYNZ2MjhNqM6QPEdNHK41fNPe0B57MXhNiPDcdcJ6vDaJ5u2RX/8wWuDHwx1gzOB9w+cPG3qG2OerheI//znP//5z/+HPGo+1u2J+mVc8S9yeWNTjL2Nb7vArMeWmJiYr9bch78lcOn6mJiYr8cBDb9aGxMTs7kTitfrm5iYmK9W18I/0+tQLsmCP6vhXxR4kY42wM5HFNLvxd/SIIPCQmAkpa4o3qcUkiLwj7xMq+uV8C+6N5uO3oadvRTivPG3PEZpNDCPQnZjFMvlNwrnXPBP1Eym1UE3/AvK1wmE0I6FDIWZ/yUKO/D3vEypI7CewuXyKJZ/AoVv8I/MoM3X+Bf0/mTmghbQvEhH+W1gVv82hQX4e5ZTyKwO7+MUDqF49TMozMU/8g2l639Mxj9Xa8X0dycshuZ9OkqrBLPWcRfOnTt3bQj+nl8oxPmjfCqFtSheV0oj8E/4n6VwtRa88M91f37mt/1fguZrSplThgy3GtnfA2YeAX6CG/6WgAsUvgceyKcwFcUbQ6kj/omKdyjE4F/RbO7kFyfPB+B7ktK5QJSOf+1GDSq6ojCfyMZVXKC4hoVXdAPqpFNYBgyk1AfFW0IhrTasvKs1ahjhhf+hZgUUJkEXdF+jRtUDUAyfiEaNqnjAzKdGo4aVXQHMWPP05l4Awu5Q2gPFZ8na6Ojo9a/C8+kVBwdg8vro6Oi173tBaLf6QlpuVsKBCSGQyq1aEx0dvWEYqsw6fScv+dsmsCr76sHriQn7n8cjlF4D3qDUNOjTNdHR0Zueh+A+c1109IYZMHxH4bIXNC5tPo5Nzs1Jiv2kBTRllsVER0dvGAZN0JK10Ws+DYZm5Mbo6PWzXaHzeC96N6X9n214CkCZF77783ZubsrFzQP9IIR+HBMdHb1pGMr0/+LEU9A0WxyblJt78/jMitA1W3YmJTcn8cCkULg2G1AHmpa0WgWlZiYFS8Rukt1xhsJeNwChawtoc/EhCK0pje+ZQCmpMYQWsbTaOI1Sd+BzCjcqu56gcNQHmocojILifYnCz9CEryugTd6HfoDv7xR2QTOMmoI2ACrEUzMJyj2pNPQFuvxB5VgTaFpTeqPmMZLtAb/FebRJ6AnJe1EubRKGwuZZWo2F0pnSstMkc2uGJFJYDqDmSRqSW0AzlNLxDNqsg+ahFOqyKeTWh9teCiddsIhCfl1o1lNz3AdK9VQKSwE0Ok+Trz2ADRRO+QAehygMAjCWmr9CobTKo6EJhhbQ5Ep1AL0p5H3wF8lbYQjYTkNOV2hc19HkTVjNpNWaCVM0Mx4E8BKlrAKS5z2bFVB4DfD9jVLyLQr7PADMooMbIUCVi3SQWA6BiRS2A49RGgWgcQ41Q2DoQGkcUCGWdqYB8ykk1wB6UpoO+J2iZhoMI2hICHk4l3YWA3iHQn4GNUeBryil3qBwMQTABNp5C1IM7TwHYCENu9CLUi/gbQpZYysEv0ahF4C1tMo5coVSVhiwktLNqe3GXaK0zwP1sinMA8KvU1gL4FNqzvjDMJxSN2A5pdgp72dQSKiI4ZTaALsorQKGUHM1DIZeP3ybR+Hapm8t5U5RuL1q/GpKJ12BTTSswggKee9UKvtcFjVjgcA4atIG1uq7o4Ca9W7QeB6mnaYAttOwENMo5DZBnVQKk6D5jppowOMwpatPovZ1CllheCCXwp3WABqlUfgS6EppKIAdFC6XRWQ6NS/DZA6FzMZomkPhXBjwKqVBaEVpCB6h1R647qNmGuxE5lCYCyB4+parZFonADspnPMDDtHwsuslCouh+YSan1zQvICaI9D0T+WtYa4Qgm/RLL0S4H2e0o0Nn+3KH4QYCknlMItCXDA0U6g56YPgJAq3owDspRBXBvMpTYem3h0KbwPjKHUAMJpSFCzUnA2CyUYKCYH4kNIAADVTKSxGpXQKc7GBVvHoRE18KOx0pTQYUmCLiU9Ds5LCIaDSVUqXYz7fnf3QAArpkdD0pyblHnSmULAw0g3o/FUtWDXOo9kJXyA8ncKeigCqB+EQhUOu7scp7Ivq0KFD1AfU3K6AJrkU5gHwP0vhB3icoZAWCU1nSoOBxRRSagO4P4/ChIBEakbDxCWWwiH4naYQFwIgLJHCBvicoLCuVhat0qtuoGYq7E2i1A46r/vate/9O4X1wP0FFDaVAdzCfTdTONeufYcOrd6hJqcx6uRSyjk2+34ovWhnC4C2BRRehlT+CoUY1MyiUEAlMxR9KPUFUDuVwseon0VhN4QxlJoD31G46AvA6xSFFaOpORMEk9AbFL5EfUrroQlLpLAB2Ehh1xza3HkhheRfobC3hEJyDQiuUe/+cjObureBrpSGQAhJpFBQQKUzPPZTl7ejJWym0OrNlo9oOkYCGEGpB6TGWRTewZN0lBmKKZRaA2hLaQr6UbJAWE7hdhh84yj8DGEZhVMnqBkFs5a5FKaiB6Xp0NRMpbABmE/hj0u0uXOcmilw8D2Fcz7QNP2edvoBkym1glA/j446AV1pyJ0IqxW0agVlJoWs+yE9SWkohtJRRgV8QuFmVQBDKXXFa5RGQthN4YQPIu5QWAahK4XcfJKxZWDWj9IgjKY0CJpHKH0EDKUuazd1VyrAXsAVCj9A0yuLUnZSJqW2wOcU0itBaEFHOY0BjMmhYQgEl58oJYRDWUfhWnlIYym1wQuUZnXoInR+sku3Dq4uv1I44wpgAYX8SFgo9YOm7EUKm4B2lF6CcO8N6sbCzusUclviDUp9oBlK6VWgBXW/jKRuMhxUy6DwIYD70ihcfaVRmfco3KgK/ErhlB+EFpQ+frSL8NgTXbo+GQBNq53Z1J30gybwKqXjLtC5H6dwDFbLKWRURh9K3SH5ukLjf53Ct9Bso3A9GB9S6ghN3QwKC4FRlLpA+oE2l8rDzpcUkkLxKqWO0HxJIb8NEJ5KmwFRtLlcAQ46UxoNYCmF+PoA3qNw2hXlLlLYAqlJAYUXIHm5Q/IMB+q/vPkGpYK60ERmUdoKJSSJwhpY7aZw2heNcynMhVDt4o4oAJGZFOYB8DxB4Vc3LKbUE5q2lF4A5lDIbAxpAm0mwd4hCqc90J3SMAARSRTO+AC+x2l1wadOBq0mwdFoSo8DXr9TmAHNJgo7gLpZFBZDuieZwnoIwfv3POkJoPLXCfdBE7KaUhQ0T9BqDpTmuRTehOR/jsJ2wOsYhZSWAOodI3N/ehhdKY0AUPUGhc+BNyjNBVAmhlI74GsK8SGQWtHqzxDYKRtPYTNQM5vCVgCrKE2EZiOtxqNsPKVL98CRhUJGA6DyNQqTAYScpvAe0J7SS7DaRiH3aQBV95A82AUDEsgzTaBpRyG3OjTjadUfSl9K/SDVSafwAYCJlFKXj/simcJAjKHUEUBzSm8BfSndGVSl+wlKOffC8xSFQ7DyOU9pAuw1yqAwB8B3lDaP2UrpVBA071H6MwQ4TmkiCvmGwqUgIPAchfge1foepTQcGE2pA6wGUsr84pWl1ym8PI1C2pLOTR7fR2GvOzSLaNUayhQKBW0htac0FoD/cdp5C/iAQlokgH6U+gJhNygVZNHmYhAqJFNYDZuVFOKCYa8LpRcBdC6gWc6jEJ6l9CaA9RTiQuDI+zSFg9B8Takghza9gaUUcqrDymUr7SzHgym0NxDCTkq3qkFZSeFmZUgjKD0GzQPXaTILwLcU4nwAvE2pAYDZ1OXnU9gFPJhHYQpsBlIYBwdjKHWAZgZNbveH1JzC1YoAZlMYj0IqpVFYBc1T1OUVUOgNfEfhQhBsKh6iSbQv0OEGzeZCukzptCd0bkcoXHCDtJRCbi0ItX6gLvE5AL7xFHZD8w2F5IoA/LbR6syUOxQ+BZ6j1B82T1DzZzk4WEHhdjUIo5OpO9QKVlVSqJkJzfPU/BGMQh6hNAHCTFrtmphDoTcCz1H4EUro6nzapE+CUGdHPnW3RsNq9kKLZvEoKO7TF1kslsWjYPXchxaL5f0ZfpDcu6w9l04mHZheEZqg2QstFsuH/aB5ZbHFYvlggic0AdPP5fD2kYllKr9v0XzYGWj3kcViWWCpAZv51EyHoxGLLRbL+297QaoyY+/1O/kpZ9b19IWN16RFlgULqkBTf9ECy9JuKOz+RQssFstH90Pq/lN86qVverqVn7vQYrEsjULQW+9bLJYlA2DS+rMz6WTKsTm1YfPQ8oPX0pl26cfJ4fjbAqo1qBfujhL412oQ4YWihYRUbWnJJXm1EkriFlqjTtUA/CNu99xbDiUKiKhfv4o3TDzCqtWLCHbF/1NrUm/lU5iK/5RkG61Ol8F/SrKNUtpD+E+JtlE4/zD+U7J1eanXtr9QFneb/wPJBZaItDaVZgAAAABJRU5ErkJggg=="

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-jet2holidays.1a90f9cc.png";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-landrover.7bd33da9.png";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-jaguar.2db698e3.jpg";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-jet2.dee440d1.jpg";

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-jet2holidays.d8ba49e4.jpg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screen-landrover.e4ee9c72.jpg";

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./logo-jaguar.png": 409,
		"./logo-jet2.png": 410,
		"./logo-jet2holidays.png": 411,
		"./logo-landrover.png": 412
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 418;


/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"topWrapper":"src-layouts----layout-module---topWrapper---2TDeW","header":"src-layouts----layout-module---header---2JHpi","headerInner":"src-layouts----layout-module---headerInner---2t9ZS src-styles----global---centredContainer---3bAlq","title":"src-layouts----layout-module---title---2klHM","strapline":"src-layouts----layout-module---strapline---1un8k","container":"src-layouts----layout-module---container---3LcPI src-styles----global---centredContainer---3bAlq"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5ea82e92045e775819bb.js